import { createRouter, createWebHistory } from "vue-router";
import HomeView from '@/views/HomeVue.vue';
import FormComVue from '@/views/FormComVue.vue';
import Tab1vue from '@/views/Tab1vue.vue';
import Tab2vue from '@/views/Tab2vue.vue';
import Tab3vue from '@/views/Tab3.vue';
import ReviewView from '@/views/ReviewView.vue';


const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  { 
    path: "/formcom", 
    name: "formcom", 
    component: FormComVue 
  },
  {
    path: "/tab1",
    name: "tab1",
    component: Tab1vue,
  },
  {
    path: "/tab2",  
    name: "tab2",
    component: Tab2vue,
  },
  {
    path: "/tab3",  
    name: "tab3",
    component: Tab3vue,
  },
  {
    path: "/review",  
    name: "review",
    component: ReviewView,
  },
  
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // Always scroll to top
    return { top: 0 }
  },
});

export default router;
